import BaseCom from "../../../components/BaseCom";
import L from "../../../components/Lang";

export default class APIProperties extends BaseCom {
    render() {
        if(!this.props.properties)
            return;
        return (
            <div style={{ overflow: 'auto', maxHeight: '30rem' }}>
                <table className="table table-bordered" style={{ minWidth: '50rem' }}>
                    <tbody>
                        {this.props.properties.map((p, pdx) => <tr key={pdx}>
                            <td style={{ width: '15%' }}><strong>{p.name}</strong></td>
                            {!this.props.isResponse && <td>{p.isRequired ? <u><L>Required</L></u> : <i><L>Optional</L></i>}</td>}
                            <td>{p.description}</td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }
}